import React, { useContext, useEffect } from 'react';

import lockFailedGif from '../assets/images/lockFailedGif.gif';
import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

const renderImageBytenant = () => {
  return (
    <div className="amazonImageDiv">
      <img src={lockFailedGif} />
    </div>
  );
};

const LockFailed = () => {
  const { appData, setLoading } = useContext(UserContext);
  const approvedRateProperty = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'ApprovedRateProperty'
  );

  const handleBackToAmazonSellect = async () => {
    setLoading(true);
    window.location.href = approvedRateProperty?.displayProperties?.meta.LINE3;
    setLoading(false);
  };

  return (
    <Layout>
      <div className="lock-failed-page">
        <h1 className="title">We tried</h1>
        <div className="need-docs-header">
          <h3 className="amazon-subtitle">
            We were not able to establish a Bank Account Lock with your Amazon Seller Bank Account.
            Please contact our dedicated Call Center at 888-216-6445 to resolve this issue.
            <br />
            We're available 6am - 5pm PT Monday to Friday.
          </h3>
        </div>
        <div className="one-button">
          <button className="primary-btn" onClick={handleBackToAmazonSellect}>
            Go back to Amazon Seller Central
          </button>
        </div>
        {renderImageBytenant()}
      </div>
    </Layout>
  );
};

export default LockFailed;
